import React from 'react';
import { Stack } from 'office-ui-fabric-react';
import Module from '../../components/Module';
import ModuleContent from '../../components/ModuleContent';
import ContractStats from '../../components/ContractStats';
import StagedTransactions from './modules/stagedTransactions';

const DriStatistics = () => {
  return (
    <Module data-testid="statistics">
      <Stack horizontal disableShrink tokens={{ childrenGap: 20 }}>
        <ModuleContent>
          <ContractStats />
        </ModuleContent>
        <ModuleContent>
          <StagedTransactions />
        </ModuleContent>
      </Stack>
    </Module>
  );
};

export default DriStatistics;
